import { FC } from "react";
import { CaseInformationProps } from "../caseInformation/types";






const PatientTreatment: FC<CaseInformationProps> = ({ caseObject }): JSX.Element => {

  return (
    <>
      <div className="card mb-4">
        <div className="card-header">
          <h1 className="m-0">Provide Patient Training</h1>
        </div>
        <div className="card-body">
          <div className="row">

          
            <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Provide Patient Training:</p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.patient_training_required === "1" ? "yes" : "no"}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Target After Meal Blood Glucose Min: </p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.target_after_meal_blood_glucose_min ? caseObject.case_information.target_after_meal_blood_glucose_min : 'N/A'}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Target After Meal Blood Glucose Max: </p>
              </div>
              <div className="col-6">
                {caseObject && caseObject.case_information && caseObject.case_information.target_after_meal_blood_glucose_max ? caseObject.case_information.target_after_meal_blood_glucose_max : 'N/A'}
              </div>
            </div>
            </div>
            <div className="m-3">
              <ul>
                <li>
                    The American Diabetes Association suggests assessing post-meal blood glucose 1–2 hours after the start of a meal.
                </li>
                <li>
                    Continue adjusting dose every <strong>3–4 days</strong>, or{" "}
                    <strong>twice weekly</strong>, if blood glucose is below or above
                    target, until after-meal blood glucose is consistently within your
                    target range up to the maximum daily dose.
                </li>
                <li>
                    The American Diabetes Association suggests insulin
                    regimens be adjusted every 3–4 days until self-monitored blood glucose
                    targets are reached.
                </li>
                <li>
                    To opt out of Patient Training, please contact{" "}
                    <strong>MannKind Cares at 1-844-323-7399</strong>.
                </li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientTreatment;
